export class PrefectureModalController {
  constructor(controller) {
    this.controller = controller;
  }

  openPrefectureModal(event) {
    event.preventDefault();
    if (this.controller.hasPrefectureModalTarget) {
      this.controller.prefectureModalTarget.classList.add('is-active');
      this.initializePrefectureSelection();
    }
  }

  initializePrefectureSelection() {
    if (this.controller.formValue.prefecture_name) {
      this.controller.prefectureButtonTargets.forEach(button => {
        if (button.dataset.prefectureName === this.controller.formValue.prefecture_name) {
          button.classList.add('is-selected');
          if (!this.controller.formValue.prefecture_id) {
            this.controller.formValue = {
              ...this.controller.formValue,
              prefecture_id: button.dataset.prefectureId
            };
          }
        } else {
          button.classList.remove('is-selected');
        }
      });
    } else {
      this.controller.prefectureButtonTargets.forEach(button => {
        button.classList.remove('is-selected');
      });
    }
  }

  async selectPrefecture(event) {
    const button = event.currentTarget;
    
    this.controller.prefectureButtonTargets.forEach(btn => btn.classList.remove('is-selected'));
    button.classList.add('is-selected');
    
    this.controller.formValue = {
      ...this.controller.formValue,
      prefecture_id: button.dataset.prefectureId || null,
      prefecture_name: button.dataset.prefectureName || null,
      city_id: null,
      city_name: null
    };

    if (this.controller.hasPrefectureConfirmButtonTarget) {
      const confirmButton = this.controller.prefectureConfirmButtonTarget;
      const messageTarget = this.controller.hasPrefectureNoResultsMessageTarget ? this.controller.prefectureNoResultsMessageTarget : null;
      await this.controller.updateModalButtonState(confirmButton, messageTarget, '決定する');
    }
  }

  confirmPrefectureSelection(event) {
    event.preventDefault();
    if (this.controller.formValue.prefecture_id) {
      if (this.controller.hasPrefectureInputTextTarget) {
        this.controller.prefectureInputTextTarget.textContent = this.controller.formValue.prefecture_name;
      }

      const prefectureSelect = this.controller.element.querySelector('select[name="prefecture_id"]');

      if (prefectureSelect) {
        prefectureSelect.value = this.controller.formValue.prefecture_id || '';
      }

      // 都道府県変更時にcity_idのhidden inputをリセット
      const cityInput = this.controller.element.querySelector('input[name="city_id"]');
      if (cityInput) {
        cityInput.value = '';
      }

      // 市区町村表示をリセット
      this.controller.cityModalController.updateCityDisplay();
    }

    this.controller.closeAllModals();
  }
}
